import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './styles/css/main.css';
import { Provider } from 'react-redux';
import store from "./store";
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';
import gaTracking from "./util/tracking"

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>, document.getElementById('root'));
registerServiceWorker();
gaTracking();



// WEBPACK FOOTER //
// ./src/index.js